import React from 'react'
import { Box, Grid, Image } from '@chatterbug/aaron'
import PropTypes from 'prop-types'

import bulletcheck from './assets/bulletcheck.svg'

const NudgeCardBody = ({ text }) => {
  if (!text?.length) {
    return null
  }

  if (text.length > 1) {
    return (
      <Grid as="ul" gridTemplateColumns="auto 1fr" gridGap="1x" pl="0">
        {text.map((item, index) => (
          <React.Fragment key={index}>
            <Image src={bulletcheck} alt="" mr="0,5x" />
            <Box as="li" sx={{ listStyleType: 'none' }}>
              {item}
            </Box>
          </React.Fragment>
        ))}
      </Grid>
    )
  }
  return (
    <Box as="p" mb={{ _: '3x', tablet: '4x' }}>
      {text[0]}
    </Box>
  )
}

NudgeCardBody.propTypes = {
  text: PropTypes.array,
}

export default NudgeCardBody
